<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn icon dark title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>         
                    <help-link appId="company" pageId="linked-account-manage" color="white"></help-link>          
                    <v-btn v-if="hasEditRights" dark color="primary" title="Add New Company" @click="dialogAddLinkAccount=true">
                        <v-icon dark>add</v-icon>&nbsp;Add Linked Account&nbsp;&nbsp;
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1" style="margin-top:5px;">
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search company name" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="linked_accounts_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item.linkCompanyId)" style="cursor:pointer;" title="Click to manage linked company account">
                            <td>
                                <v-img :src="commonfn.getCompanyLogoUrlByAccount(props.item.accountNumber, props.item.logoFileName)" width="40"></v-img>
                            </td>
                            <td>{{ props.item.companyName }}</td>
                            <td>{{ props.item.employeeCount }}</td>
                            <td>
                                <div style="margin-left:-5px;">
                                    <v-chip small v-for="(item,index) in props.item.admins" :key="index">
                                        <v-avatar size="30">
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.parentUserId)"></v-img>
                                        </v-avatar>
                                        {{item.firstName}} {{item.lastName}}
                                    </v-chip> 
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
        <v-dialog v-model="dialogAddLinkAccount" persistent width="600">
            <add-link-account :dialogAddLinkAccount.sync="dialogAddLinkAccount" @send="viewDetails"></add-link-account>
        </v-dialog>
    </v-layout>
</template>

<script>

import commonfn from '@/common/functions'
import companyApi from '@/api/company'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {
    name: 'LinkedAccounts',
    metaInfo: {
        title: 'Company Linked Accounts',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Company Linked Accounts' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-link-account': ()=> import("@/components/Company/AddLinkedAccount"),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            rowsPerPageItems,
            commonfn,
            awsS3Helper,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            search: null,
            headers: [
                {text:'Company Logo', align:'left', value:'projectCode', width:'10%', sortable:false},
                {text:'Company Name', align:'left', value:'companyName', width:'40%', sortable:true},
                {text:'Employees', align:'left', value:'employeeCount', width:'10%', sortable:true},
                {text:'Admins', align:'left', value:'', width: '40%', sortable:false},
            ],
            dialogAddLinkAccount: false,
            linked_accounts: []
        }
    },
    methods: {
        viewDetails(linkCompanyId){
            this.$router.push(`/company/link/${linkCompanyId}`)
        },
        async getLinkedAccounts(show_loading) {
            try {
                this.loading = show_loading
                const response = await companyApi.getLinkedAccounts()
                if (response && response.status == 200) {
                    this.linked_accounts = response.data.accounts
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() {
        this.getLinkedAccounts(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Linked Company Accounts'
        })
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },        
        linked_accounts_filtered() {
            if (this.linked_accounts.length) {
                if (this.search) {
                    const temp = this.linked_accounts.filter(item => {
                        return item.companyName.toLowerCase().includes(this.search.toLowerCase())
                    })
                    return temp
                }
                return this.linked_accounts
            }
        },        
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>